"use strict";
exports.__esModule = true;
exports.MockData = void 0;
var mock_data_1 = require("./mock-data");
exports.MockData = mock_data_1.MockData;
